import React, { Component } from 'react';
import { Drawer, Intent, Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import colors from 'utils/colors';
import { DialogWrapper } from 'components/DialogWrapper';
import {
  DrawerHeader,
  FlexRow,
  BlueTextPointer,
  PlainButton,
} from 'components/styled-components';
import cloneDeep from 'lodash/cloneDeep';
import FormTextAreaGroup from 'components/forms/components/form-text-area-group';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import { createPrescreenAnswer } from 'api/prescreen';
import { AppToaster } from 'components/AppToaster';
import { CategorySelect } from 'components/forms/questionnaire-management/category-select';
import {
  BreadCrumb,
  Question,
  QuestionLabel,
  ScrollWrapper,
} from 'containers/Manage-Questionnaire/styled-components';

const initialState = {
  editMade: false,
  answer: { answer: '', displayCategory: null },
  closeWithoutSaving: false,
  answerError: false,
  displayCategoryError: false,
  returnToParent: false,
};

class PrescreenAddAnswerDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = cloneDeep(initialState);
  }

  handleCloseDrawer = () => {
    if (this.state.editMade) {
      this.toggleCloseWithoutSaving();
    } else {
      this.resetState();
      this.props.closeDrawer();
    }
  };

  resetState = () => this.setState(cloneDeep(initialState));

  returnToParent = () => {
    if (this.props.isParentOpen) {
      this.handleCloseDrawer();
    } else {
      this.handleCloseDrawer();
      this.props.openParent();
    }
  };

  handleTextEdit = ({ target }) => {
    const { value } = target;
    const { answer } = this.state;
    answer.answer = value;
    this.setState({ answer, editMade: true });
    this.validateAnswerValue(value);
  };

  validateAnswerValue = answerValue => {
    if (answerValue.length > 0) {
      this.setState({ answerError: false });
    } else {
      this.setState({ answerError: true });
    }
  };

  validateCategoryValue = categoryValue => {
    this.setState({
      displayCategoryError: categoryValue.length === 0 ? true : false,
    });
  };

  handleAnswerCategoryChange = value => {
    this.validateCategoryValue(value);
    const { answer } = this.state;
    answer.displayCategory = value;
    this.setState({ answer, editMade: true });
  };

  toggleCloseWithoutSaving = () =>
    this.setState({ closeWithoutSaving: !this.state.closeWithoutSaving });

  handleCreateAnswer = () => {
    const { answer } = this.state;
    createPrescreenAnswer(answer, this.props.question.questionID)
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        this.props.fetchPrescreenQuestions();
        this.setState({ editMade: false });
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
      });
  };

  handleCreateLocalAnswer = (answer, index) => {
    this.props.handleCreateAnswer(answer, index);
    this.resetState();
    this.props.closeDrawer();
  };

  render() {
    const { answer, editMade, answerError, displayCategoryError } = this.state;
    const { question, isOpen, index } = this.props;

    return (
      <Drawer
        isOpen={isOpen}
        onClose={this.handleCloseDrawer}
        hasBackdrop={!this.props.isParentOpen}
      >
        <DrawerHeader>
          Add Answer
          {editMade ? (
            <FlexRow fontSize="0.7rem" width="15rem">
              <BlueTextPointer onClick={this.toggleCloseWithoutSaving}>
                DISCARD
              </BlueTextPointer>
              <PlainButton
                onClick={
                  this.props.newQuestion
                    ? () => this.handleCreateLocalAnswer(answer, index)
                    : this.handleCreateAnswer
                }
                disabled={
                  answerError ||
                  displayCategoryError ||
                  answer.answer === '' ||
                  answer.displayCategory === null
                }
              >
                SAVE CHANGES
              </PlainButton>
            </FlexRow>
          ) : (
            <Icon
              icon={IconNames.CROSS}
              iconSize={Icon.SIZE_LARGE}
              onClick={this.handleCloseDrawer}
              style={{ cursor: 'pointer' }}
            />
          )}
        </DrawerHeader>
        <BreadCrumb
          onClick={() => {
            if (this.state.editMade) {
              this.setState({
                returnToParent: true,
                closeWithoutSaving: true,
              });
            } else {
              this.returnToParent();
            }
          }}
        >
          <Icon icon={IconNames.CHEVRON_LEFT} iconSize={25} />
          <span>Edit Question</span>
        </BreadCrumb>
        <ScrollWrapper>
          <QuestionLabel>Question</QuestionLabel>
          <Question>{question.question}</Question>
          {answerError && (
            <ErrorWrapper>The answer field cannot be blank.</ErrorWrapper>
          )}
          <FormTextAreaGroup
            label="Answer"
            requiredLabel={false}
            name="answer"
            fill={true}
            value={answer.answer}
            handleChange={this.handleTextEdit}
            style={{ background: colors.formBackground }}
          />
          {displayCategoryError && (
            <ErrorWrapper>
              An answer must have at least 1 category.
            </ErrorWrapper>
          )}
          <CategorySelect
            categories={this.props.categories}
            value={answer.displayCategory}
            handleAnswerCategoryChange={this.handleAnswerCategoryChange}
          />
          <DialogWrapper
            isOpen={this.state.closeWithoutSaving}
            onClose={this.toggleCloseWithoutSaving}
            title="You have unsaved changes on this page"
            body="If you leave this page, all unsaved changes will be lost. Are you sure you want to leave this page?"
            confirm="DISCARD CHANGES"
            action={() => {
              if (this.state.returnToParent) {
                this.setState(
                  { editMade: false, closeWithoutSaving: false },
                  () => this.returnToParent()
                );
              } else {
                this.setState(
                  { editMade: false, closeWithoutSaving: false },
                  () => this.handleCloseDrawer()
                );
              }
            }}
          />
        </ScrollWrapper>
      </Drawer>
    );
  }
}

export default PrescreenAddAnswerDrawer;
